import cx from 'classnames';
import { Component, h } from 'preact';
import { select, selectAll, pie, entries, arc, line, curveBasis } from 'd3';

import context from 'Data/text.json';

import { DEMOCRAT, NEUTRAL, REPUBLICAN, TIE } from '../colors';

const svgPadding = 4;

// Final canvass version of pieData
const pieData = [
  {name: "R", color: "#EF564A", value: 50},
  {name: "D", color: "#1755c5", value: 50},
];

// Election night version of pieData
// const pieData = [
//   { name: 'D', color: '#1755c5', value: 33 },
//   {name: "not voted", color: "#bdbdbd", value: 33},
//   { name: 'R', color: '#EF564A', value: 33 },
// ];
const pieGen = pie().value(d => d.value.value);

class MapText extends Component {
  // ({ typeMap, candidates, includesNoResult, includesTie, rScale })
  constructor() {
    super();
    this.state = {};


    this.drawPieLegends = this.drawPieLegends.bind(this);
  }

  drawPieLegends(props) {
    // types
    const typeRace = props.embedType == 'homepage'? 'all-map-stuff' : props.typeRace;

    // pie legend
    const pieSvgSize = Math.min(Math.round((50 / 620) * props.width * 2), 40);
    const pieRadius = pieSvgSize / 2;

    select(`#${typeRace}`).select('.below-map').select('.pie-g').remove();

    const pieSvg = select(`#${typeRace}`)
      .select('.breakdown-legend-item')
      .select('svg')
      .attr('width', pieSvgSize)
      .attr('height', pieSvgSize);

    const pieG = pieSvg.append('g').attr('class', 'pie-g');
    pieG
      .append('g')
      .attr('class', 'paths')
      .attr('transform', `translate(${pieSvgSize / 2}, ${pieSvgSize / 2})`)
      .selectAll('path')
      .data(pieGen(entries(pieData)))
      .enter()
      .append('path')
      .attr('d', arc().innerRadius(0).outerRadius(pieRadius))
      .attr('fill', d => d.data.value.color);
    // R and D text
    const textG = pieG
      .append('g')
      .attr('class', 'pie-text')
      .attr('text-anchor', 'middle')
      .style('font-weight', 'bold')
      .attr('fill', 'white');
    textG
      .append('text')
      // .attr('transform', `translate(${pieSvgSize / 4}, ${pieSvgSize / 3 + 5})`) // election night letter position
      .attr('transform', `translate(${pieSvgSize / 4}, ${pieSvgSize / 2 + 3})`) // final canvass letter position
      .text('R');
    textG
      .append('text')
      // .attr(
      //   'transform',
      //   `translate(${pieSvgSize * 3 / 4}, ${pieSvgSize / 3 + 5})`
      // ) // election night letter position
      .attr('transform', `translate(${pieSvgSize * 3 / 4}, ${pieSvgSize / 2 + 3})`) // final canvass letter position
      .text('D');


    // size legend
    select(`#${typeRace}`).select('.below-map').select('.text-g').remove();
    const sizeSvg = select(`#${typeRace}`)
      .select('.breakdown-annotation')
      .select('svg')
      .attr('width', props.width)
      .attr('height', props.height);
    const sizeTextG = sizeSvg.append('g').attr('class', 'text-g');
    const sizeText = sizeTextG
      .append('text')
      .attr(
        'transform',
        `translate(${props.border.elPaso[0] + 20}, ${props.border.marverick[1] + 20})`
      )
      .attr('text-anchor', 'start')
      .attr('fill', '#333333');
    sizeText
      .append('tspan')
      .attr('x', 0)
      .attr('dy', 0)
      .text('Circles are sized');
    sizeText
      .append('tspan')
      .attr('x', 0)
      .attr('dy', 12)
      .text('by voter turnout');
    sizeText.append('tspan').attr('x', 0).attr('dy', 12).text('in each county');

    // arrow
    // arrow defs
    const arrowPoints = [
      [0, 0],
      [0, 5],
      [5, 2.5],
    ];
    sizeTextG
      .append('defs')
      .append('marker')
      .attr('id', 'arrow')
      .attr('viewBox', [0, 0, 20, 15])
      .attr('refX', 0)
      .attr('refY', 2.5)
      .attr('markerWidth', 20)
      .attr('markerHeight', 15)
      .attr('orient', 'auto-start-reverse')
      .append('path')
      .attr('d', line()(arrowPoints))
      .attr('stroke', '#333333')
      .attr('fill', '#333333');

    const points = [
      { x: -5, y: 0 },
      {
        x: props.width > 500 ? -30 : -25,
        y: -(props.border.marverick[1] - props.border.elPaso[1] - 30) / 2,
      },
      { x: -20, y: -(props.border.marverick[1] - props.border.elPaso[1] - 30) },
    ];
    const arrowGen = line()
      .x(p => p.x)
      .y(p => p.y)
      .curve(curveBasis);
    const arrowG = sizeTextG
      .append('g')
      .attr('class', 'arrow')
      .attr(
        'transform',
        `translate(${props.border.elPaso[0] + 20}, ${props.border.marverick[1]})`
      )
      .append('path')
      .attr('d', arrowGen(points))
      .attr('fill', 'none')
      .attr('stroke', '#333333')
      .attr('stroke-width', 1)
      .attr('marker-end', 'url(#arrow)');
  }

  componentDidUpdate(prevProps) {
    const { typeMap } = this.props;

    if (prevProps != this.props) {
      if (typeMap == 'breakdown') {
        this.drawPieLegends(this.props);
       
      }
    }
  }

  render() {
    const { typeMap, candidates, includesNoResult, includesTie, embedType } = this.props;


    return (
      <div>
        {typeMap == 'categorical' && (
          <div class="results-map__text">
            <div class="results-map__legend">
              <table>
               
                {includesNoResult && (
                  <div class="results-map__legend-item">
                    <span
                      class="circle-pill"
                      style={{ backgroundColor: NEUTRAL }}
                    />{' '}
                    <p class="results-map__legend-label">No votes</p>
                  </div>
                )}
                 {includesTie && (
                  <div class="results-map__legend-item">
                    <span
                      class="circle-pill"
                      style={{ backgroundColor: TIE }}
                    />{' '}
                    <p class="results-map__legend-label">Tied</p>
                  </div>
                )}

                {candidates.map(candidate => {
              return (
                  <tr class='results-map__legend-item'>
                  <td>{candidate.name.split(' ')
                    .pop()
                    .trim()}</td>
                 <td>
                  <span
                    class={cx(
                      'circle-pill',
                      `pill--${candidate.party.slice(0, 3).toLowerCase()}-lean`
                    )}
                  />
                  <span class='legend-item-text'>{'< 10%'}</span>
                  </td>
                  <td>  <span
                    class={cx(
                      'circle-pill',
                      `pill--${candidate.party.slice(0, 3).toLowerCase()}`
                    )}
                  />

                 <span class='legend-item-text'>{'> 10%'}</span>
                  </td>
                  </tr>
          
              );
            })}
                {/* <span
                    class={cx(
                      'circle-pill',
                      `pill--${candidate.party.slice(0, 3).toLowerCase()}-lean`
                    )}
                  />{' '}
                  <p class="results-map__legend-label">
                    {candidate.name.split(' ')
                    .pop()
                    .trim()} by less than 10%
                  </p> */}
              </table>
            </div>
          </div>
        )}
        {typeMap == 'breakdown' && (
          <div>
            <div class="results-map__text breakdown-text">
              <div class="results-map__legend breakdown-legend">
                <div class="breakdown-legend-item">
                  <div class="breakdown-legend-title">Share of votes for:</div>
                  <svg></svg>
                  {/* <div class="breakdown-legend-annotation">Estimated votes<br />left to count</div> */}
                </div>
              </div>
            </div>
            <div class="breakdown-annotation">
              <svg></svg>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default MapText;
